import { FormatRelativeDateAbbreviated, FormatTime } from "~/lib/date";
import { CombinedPossibleJobs, JobsEdge } from "~/pages/cicd/utils/cicdTypes";

export const formattedPipelineKind = (pipelineKind: string) => {
  switch (pipelineKind) {
    case "PULL_REQUEST":
      return "Pull Request";
    case "BRANCH":
      return "Branch";
    case "TAG":
      return "Tag";
    default:
      return pipelineKind;
  }
};

export const formattedDate = (date: string) =>
  `${FormatRelativeDateAbbreviated(date)} - ${FormatTime(date)}`;

export const getGitWorkflows = (job: CombinedPossibleJobs) => {
  switch (job.__typename) {
    case "GitlabJob":
      return `${job.jobStage} - ${job.jobName} - ${job.target}`;

    case "GithubJob":
      return `${job.workflow} - ${job.job} - ${job.target}`;
  }
};

export // Return an array of the properties that should get compared
// dependent on the type of job. fallback is to return an empty
// array meaning abort groupings and just print out the list.
const getComparators = (edge: JobsEdge): string[] => {
  if (!edge || !edge.node) return [];

  const type = edge.node.__typename;

  if (type === "GithubJob") {
    return [
      edge.node.job,
      edge.node.ref,
      edge.node.repository,
      edge.node.runId,
      edge.node.sha,
    ];
  }

  if (type === "GitlabJob") {
    return [
      edge.node.commitSha,
      edge.node.commitRefName,
      edge.node.jobId,
      edge.node.jobStage,
      edge.node.projectUrl,
    ];
  }

  if (type === "CircleCIJob") {
    return [
      edge.node.commitSha,
      edge.node.job,
      edge.node.jobId,
      edge.node.projectUrl,
    ];
  }

  if (type === "AzureDevopsJob") {
    return [
      edge.node.commitSha,
      edge.node.job,
      edge.node.jobId,
      edge.node.projectUrl,
    ];
  }
  if (type === "JenkinsJob") {
    return [
      edge.node.commitSha,
      edge.node.job,
      edge.node.jobId,
      edge.node.projectUrl,
    ];
  }
  if (type === "KubernetesJob") {
    return [edge.node.namespace];
  }

  return [];
};

// This function is taking in an array of edges and grouping them
// by matching the provided matchers returned in the getComparators function
// i.e. sha, ref, repository, job, runId
export const groupByJobByRelatedScans = <T, _F>(
  array: T[],
  f: (o: T) => string[],
): T[][] => {
  let groups: { [key: string]: T[] } = {};
  array.forEach((o) => {
    let group = JSON.stringify(f(o));
    groups[group] = groups[group] || [];
    groups[group].push(o);
  });
  return Object.keys(groups).map((group) => groups[group]);
};

// helper function that returns whether or not a given
// string is valid JSON
export const isJsonString = (str: string) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};
